export enum LayerDateStep {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
}
